export class BrowserFingerprint {
  static async init() {
    // 获取浏览器指纹
    let fingerprint = await BrowserFingerprint.get();
    console.log("浏览器指纹：", fingerprint)
    if(fingerprint){
      window.localStorage.setItem('browserFingerprint', fingerprint);
    }else {
      window.localStorage.setItem('browserFingerprint', '');
    }
  }


  // 原生浏览器指纹 - 企业ERP专用（稳定+唯一+无依赖）
  static async get() {
    const nav = navigator;
    const scr = screen;

    // 采集Canvas指纹
    const canvasFingerprint = await this.getCanvasFingerprint();

    // 采集WebGL指纹
    const webglFingerprint = this.getWebGLFingerprint();

    // 采集插件信息
    const plugins = this.getPluginsInfo();

    // 固定顺序采集【绝对稳定】特征
    const parts = [
      nav.userAgent,                      // 浏览器标识
      nav.platform,                       // 系统平台
      scr.width + 'x' + scr.height,      // 屏幕分辨率
      scr.colorDepth,                     // 色深
      scr.pixelDepth || '',               // 像素深度
      nav.hardwareConcurrency || '',      // CPU核心数
      nav.deviceMemory || '',             // 运行内存
      nav.language || '',                 // 语言设置
      nav.languages ? nav.languages.join(',') : '', // 所有语言
      new Date().getTimezoneOffset(),     // 时区偏移
      nav.cookieEnabled ? '1' : '0',     // Cookie启用状态
      nav.onLine ? '1' : '0',            // 在线状态
      nav.maxTouchPoints || '0',         // 触摸点数量
      nav.webdriver ? '1' : '0',         // 是否为自动化测试
      canvasFingerprint,                  // Canvas指纹
      webglFingerprint,                   // WebGL指纹
      plugins                             // 插件信息
    ];

    // 拼接字符串
    const str = parts.join('||');

    // 哈希函数（带降级方案）
    async function hash(s) {
      try {
        // 尝试使用 Web Crypto API（安全上下文）
        // 严格检查 crypto 和 crypto.subtle 是否存在
        if (typeof crypto !== 'undefined' &&
          crypto.subtle &&
          typeof crypto.subtle.digest === 'function') {
          const encoder = new TextEncoder();
          const data = encoder.encode(s);
          const digest = await crypto.subtle.digest('SHA-256', data);
          // SHA-256 返回完整的64位十六进制字符串
          return Array.from(new Uint8Array(digest))
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
        }
      } catch (e) {
        console.warn('Web Crypto API 不可用，使用备用哈希方法', e);
      }

      // 降级方案：使用简单的哈希算法（返回32位）
      return BrowserFingerprint.simpleHash(s);
    }

    // 返回指纹（SHA-256为64位，降级方案为32位）
    return hash(str);
  }

  // 获取Canvas指纹
  static async getCanvasFingerprint() {
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = 200;
      canvas.height = 50;

      // 绘制文本和图形
      ctx.textBaseline = 'top';
      ctx.font = '14px Arial';
      ctx.fillStyle = '#f60';
      ctx.fillRect(10, 10, 100, 30);
      ctx.fillStyle = '#069';
      ctx.fillText('Browser Fingerprint', 10, 10);
      ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
      ctx.fillText('Browser Fingerprint', 2, 15);

      // 转换为DataURL并哈希
      const dataURL = canvas.toDataURL();
      return this.simpleHash(dataURL);
    } catch (e) {
      console.warn('Canvas指纹获取失败', e);
      return 'canvas_not_supported';
    }
  }

  // 获取WebGL指纹
  static getWebGLFingerprint() {
    try {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

      if (!gl) {
        return 'webgl_not_supported';
      }

      // 获取渲染器信息
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      if (debugInfo) {
        const vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
        const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
        return `${vendor}||${renderer}`;
      }

      return 'webgl_no_debug_info';
    } catch (e) {
      console.warn('WebGL指纹获取失败', e);
      return 'webgl_error';
    }
  }

  // 获取插件信息
  static getPluginsInfo() {
    try {
      const nav = navigator;
      if (!nav.plugins || nav.plugins.length === 0) {
        return 'no_plugins';
      }

      // 提取插件名称列表
      const pluginNames = [];
      for (let i = 0; i < Math.min(nav.plugins.length, 10); i++) {
        pluginNames.push(nav.plugins[i].name);
      }

      return pluginNames.join(',');
    } catch (e) {
      console.warn('插件信息获取失败', e);
      return 'plugins_error';
    }
  }

  // 简单的字符串哈希算法（降级方案）- 生成更长更唯一的哈希
  static simpleHash(str) {
    if (str.length === 0) return '0000000000000000';

    // 使用多个哈希种子，生成更长的哈希值
    const seeds = [0x811c9dc5, 0xcbf29ce4, 0x6c62272e, 0x9e3779b9];
    let result = '';

    for (let seed of seeds) {
      let hash = seed;
      for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = Math.imul(hash ^ char, 0x5bd1e995);
        hash ^= hash >>> 15;
      }
      // 确保正数并转为16进制（8位）
      result += Math.abs(hash).toString(16).padStart(8, '0');
    }

    // 返回32位十六进制字符串（128位哈希）
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/common/BrowserFingerprint.js